import EfCouponTop from '@elem/ui/ef-coupon-top';
import EfLink from '@elem/ui/ef-link';
import { useRouter } from 'next/router';
import { Fragment } from 'react';
import './index.scss';
import { textLang } from './textLang';
export default function CheckInCouponList({ redeemSkipUrl, listCouponB = [] }: { redeemSkipUrl?: string; listCouponB?: any }) {
    const { locale = 'us' } = useRouter();
    const TextA = textLang[locale] || textLang['us'];
    return (
        <EfLink
            className="ef-check-in-CheckInCouponList"
            href={redeemSkipUrl}
            dataLayer={{
                event: 'uaEvent',
                event_name: 'jump_button',
                position: 'Swap EcoCredits for Splendid Gifts',
                button_name: 'Swap EcoCredits for Splendid Gifts',
                url: redeemSkipUrl,
            }}
        >
            <div className="ef-check-in-CheckInCouponList-l">
                <div className="ef-check-in-CheckInCouponList-l-ms1">{TextA.title}</div>
                <div className="ef-check-in-CheckInCouponList-l-ms2">
                    {TextA.desc}
                    <span className="ef-check-in-CheckInCouponList-l-btn">{TextA.btn}</span>
                </div>
            </div>
            <div className="ef-check-in-CheckInCouponList-r">
                {listCouponB.map((item: any, index: number) => {
                    return (
                        <Fragment key={index}>
                            <EfCouponTop sqlItemData={item} />
                        </Fragment>
                    );
                })}
            </div>
        </EfLink>
    );
}
